export enum RegulationsTypes {
  platform = 100001,
  informationClause = 100002,
  programForCustomer = 100003,
  programForClerk = 100004,
  privacyPolicy = 100005,
  quickAppGuide = 100006
}